import { constants } from './showmore.constant'
import { showMoreSelectors } from './showmore.selector'

export const ShowMoreComponent = (() => {
	const setShowMoreInstance = (target: HTMLElement) => {
		if (!target.hasAttribute(constants.selector.target)) {
			return
		}

		const fullText = target.getAttribute(constants.selector.fullText) || ''
		const textWrapper = document.createElement('div')
		textWrapper.className = 'showmore-text'
		textWrapper.textContent = fullText
		textWrapper.style.overflow = 'hidden'
		textWrapper.style.textOverflow = 'ellipsis'
		textWrapper.style.whiteSpace = 'nowrap'

		target.textContent = ''
		target.appendChild(textWrapper)

		const isTruncated = textWrapper.scrollWidth > textWrapper.clientWidth

		if (isTruncated) {
			let isOpen = false

			const button = document.createElement('button')
			button.className = 'text-primary-400 underline hover:no-underline ml-2'
			button.innerText = target.getAttribute(constants.selector.showMoreText) || 'Show More'
			button.type = 'button'

			button.addEventListener('click', (event) => {
				event.preventDefault()
				event.stopPropagation()
				isOpen = !isOpen

				if (isOpen) {
					textWrapper.style.whiteSpace = 'normal'
					button.innerText = target.getAttribute(constants.selector.showLessText) || 'Show Less'
				} else {
					textWrapper.style.whiteSpace = 'nowrap'
					button.innerText = target.getAttribute(constants.selector.showMoreText) || 'Show More'
				}
			})

			target.appendChild(button)
		}
	}

	const initTargets = () => {
		const targets = showMoreSelectors.getTargets()
		for (let i = 0, { length } = targets; i < length; i++) {
			setShowMoreInstance(targets[i])
		}
	}

	const init = () => {
		initTargets()
	}

	return {
		init,
	}
})()
